/*
  ez-fc-atc — in-place "Add to cart" for single-SKU catalog cards (ez-faceted-catalog, setting card_cta).

  Same contract as the PDP buy box (ez-pdp-buy-hero.js): POST /cart/add.js, then dispatch `ez:cart:added`,
  which opens the shared cart drawer (ez-cart-drawer.js) and refreshes the header count (ez-header.js).
  If the add fails (network, sold out since render, 422), fall back to the product page, where the buyer
  sees the real state, instead of leaving a dead button.

  Only buttons rendered with [data-ez-fc-atc] are wired (ez-fc-card.liquid emits them for one-variant,
  real-SKU accessories only). Delegated on document, so cards shown/hidden by the pill filter just work.
*/
(function () {
  if (window.__ezFcAtc) return;
  window.__ezFcAtc = true;

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ez-fc-atc]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (res) {
        document.dispatchEvent(new CustomEvent('ez:cart:added', { detail: { items: (res && res.items) || res } }));
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-added');
        btn.textContent = 'Added ✓';
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.textContent = label;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        window.location.href = btn.getAttribute('data-href') || '/cart';
      });
  });
})();
